import { useQuery } from "@tanstack/react-query";

import { IAllUniversities } from "../models";
import { getUniversityById } from "../queries";
import { universitiesConst } from "..";

export const useUniversityById = (univerId?: string | string[]) => {
  const { data: university, ...args } = useQuery<IAllUniversities>({
    queryKey: [universitiesConst.queryKeys.UNIVERSITY_BY_ID, univerId],
    queryFn:  getUniversityById(univerId),
    enabled: !!univerId,
  });

  return { university, ...args };
};
